module.exports = {"410422001":"九龙街道","410422002":"昆阳街道","410422003":"盐都街道","410422101":"任店镇","410422102":"保安镇","410422103":"仙台镇","410422105":"叶邑镇","410422106":"廉村镇","410422107":"常村镇","410422108":"辛店镇","410422109":"洪庄杨镇","410422110":"龚店镇","410422201":"夏李乡","410422203":"马庄回族乡","410422204":"田庄乡","410422207":"龙泉乡","410422208":"水寨乡","410422210":"邓李乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410422.json
// module id = 1559
// module chunks = 0